import React from 'react';
import styled from '@emotion/styled';

import PlannerList from "./Planner/PlannerList";
import AddPlanner from "./Planner/AddPlanner";

import { getCurrentDate } from './helpers/helpers';

const Title = styled.h1`
  border-bottom: 2px solid ${props => props.theme.colors.dark};
  color: ${props => props.theme.colors.dark};
  display: flex;
  align-items: center;
  font-weight: 700;
  font-size: ${props => props.theme.size.large};
  min-height: 80px;
  padding-right: ${props => props.theme.size.small};
  padding-left: ${props => props.theme.size.small};
  text-transform: uppercase;
  width: 100%;

  ${props => props.theme.breakpoint.tablet} {
    font-size: ${props => props.theme.size.xlarge};
    min-height: 100px;
    padding-right: 120px;
    padding-left: 25px;
  }
`;

const CurrentDate = styled.p`
  color: ${props => props.theme.colors.dark};
  font-size: ${props => props.theme.size.small};
  font-weight: 500;
  position: absolute;
  top: ${props => props.theme.size.xsmall};
  right: ${props => props.theme.size.xsmall};

  ${props => props.theme.breakpoint.tablet} {
    font-size: ${props => props.theme.size.large};
    top: ${props => props.theme.size.large};
    right: ${props => props.theme.size.large};
  }
`;

class LandingPage extends React.Component {
  render() {

    const Container = styled.div`
      border: 2px solid ${props => props.theme.colors.dark};
      margin: ${props => props.theme.size.medium} auto;
      max-width: calc(100% -  ${props => props.theme.size.xlarge});
      outline: 0;
      position: relative;
      width: 1000px;

      ${this.props.intro &&
        `
        border-bottom: 0;
      `}
    `;

    return (
      <Container>
        <Title>Your Learning Activity Planner</Title>
        <CurrentDate>{getCurrentDate()}</CurrentDate>
        <PlannerList activities={this.props.activities} removePlanner={this.props.removePlanner} />
        { this.props.intro || <AddPlanner addPlanner={this.props.addPlanner} /> }
      </Container>
    );
  }
}

export default LandingPage;
